import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Deal } from '../model';
import { ActivatedRoute } from '@angular/router';
import { BillingServiceService } from '../billing-service.service';
import { ConfirmationService } from 'primeng/api';
import { FPAPipe } from '../pipes/fpa.pipe';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-payment-preview',
  standalone: true,
  imports: [
    TranslateModule,
    ReactiveFormsModule, CommonModule,
    ButtonModule, FPAPipe, DatePipe, TableModule
  ],
  templateUrl: './payment-preview.component.html',
  styleUrl: './payment-preview.component.scss'
})
export class PaymentPreviewComponent {

  deal: Deal | null = null;
  private paymentRef = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private billingService: BillingServiceService,
    protected translateService: TranslateService) {
    this.activatedRoute.params.subscribe(async params => {
      this.paymentRef = params["ref"];
      this.billingService.getPreviewDeal(this.paymentRef).subscribe(deal => {
        this.deal = deal;
      });
    });
  }
}
